import { SxProps, Theme } from '@mui/material'

export const editableTabSx: SxProps<Theme> = {
    textAlign: 'left',
    paddingRight: 7,

    '& .edit-button': {
        opacity: 0,
        pointerEvents: 'none',
    },

    '&:hover .edit-button': {
        opacity: 1,
        pointerEvents: 'auto',
    },
}
